export default {
  serverURI: '',
  fixedLayout: false,
  hideLogoOnMobile: false,
  project: 'sd272021'
}



// WEBPACK FOOTER //
// ./src/config/index.js